import { Service } from '@/request/http.js'

// 操作收藏：收藏 和 取消收藏
export function doCollect (data) {
  return Service({
    url: '/api/doCollect',
    method: 'post',
    params: data
  })
}

// 收藏列表：首页 和 我的收藏列表
export function myCollect (data) {
  return Service({
    url: '/api/myCollect',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/collect.js